/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetTablesManagementConfigurationDownloadParams,
  GetTablesManagementConfigurationInline200One,
  GetTablesManagementConfigurationInlineParams,
  GetTablesManagementConfigurationParallel200One,
  GetTablesManagementConfigurationParallelParams,
  PostTablesManagementConfiguration200,
  PostTablesManagementConfigurationBody,
  PostTablesManagementConnectivityErrors200,
  PostTablesManagementConnectivityErrorsBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Inventory of all captured configuration files
 * @summary Configuration Files
 */
export const postTablesManagementConfiguration = (
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesManagementConfiguration200>({
    url: `/tables/management/configuration`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesManagementConfigurationBody,
    signal,
  });
};

export const getPostTablesManagementConfigurationQueryKey = (
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
) => {
  return [
    `/tables/management/configuration`,
    postTablesManagementConfigurationBody,
  ] as const;
};

export const getPostTablesManagementConfigurationQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
  TError = unknown,
>(
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesManagementConfigurationQueryKey(
      postTablesManagementConfigurationBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesManagementConfiguration>>
  > = ({ signal }) =>
    postTablesManagementConfiguration(
      postTablesManagementConfigurationBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesManagementConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesManagementConfiguration>>
>;
export type PostTablesManagementConfigurationQueryError = unknown;

export function usePostTablesManagementConfiguration<
  TData = Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
  TError = unknown,
>(
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementConfiguration>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementConfiguration<
  TData = Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
  TError = unknown,
>(
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementConfiguration>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementConfiguration<
  TData = Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
  TError = unknown,
>(
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Configuration Files
 */

export function usePostTablesManagementConfiguration<
  TData = Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
  TError = unknown,
>(
  postTablesManagementConfigurationBody: PostTablesManagementConfigurationBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConfiguration>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesManagementConfigurationQueryOptions(
    postTablesManagementConfigurationBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Download configuration file with specific hash - configuration file ID
 * @summary Download Configuration File
 */
export const getTablesManagementConfigurationDownload = (
  params: GetTablesManagementConfigurationDownloadParams,
  signal?: AbortSignal,
) => {
  return apiClient<string>({
    url: `/tables/management/configuration/download`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTablesManagementConfigurationDownloadQueryKey = (
  params: GetTablesManagementConfigurationDownloadParams,
) => {
  return [
    `/tables/management/configuration/download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTablesManagementConfigurationDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTablesManagementConfigurationDownloadQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>
  > = ({ signal }) => getTablesManagementConfigurationDownload(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTablesManagementConfigurationDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>
>;
export type GetTablesManagementConfigurationDownloadQueryError = void;

export function useGetTablesManagementConfigurationDownload<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationDownloadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationDownload<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationDownload<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download Configuration File
 */

export function useGetTablesManagementConfigurationDownload<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationDownload>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTablesManagementConfigurationDownloadQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compare first and second configuration file in an inline mode - use hash as a configuration file ID
 * @summary Inline Mode Configuration File Comparison
 */
export const getTablesManagementConfigurationInline = (
  params: GetTablesManagementConfigurationInlineParams,
  signal?: AbortSignal,
) => {
  return apiClient<GetTablesManagementConfigurationInline200One | string>({
    url: `/tables/management/configuration/inline`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTablesManagementConfigurationInlineQueryKey = (
  params: GetTablesManagementConfigurationInlineParams,
) => {
  return [
    `/tables/management/configuration/inline`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTablesManagementConfigurationInlineQueryOptions = <
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationInlineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTablesManagementConfigurationInlineQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>
  > = ({ signal }) => getTablesManagementConfigurationInline(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTablesManagementConfigurationInlineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>
>;
export type GetTablesManagementConfigurationInlineQueryError = void;

export function useGetTablesManagementConfigurationInline<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationInlineParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationInline<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationInlineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationInline<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationInlineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Inline Mode Configuration File Comparison
 */

export function useGetTablesManagementConfigurationInline<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationInlineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationInline>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTablesManagementConfigurationInlineQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compare first and second configuration file in a parallel mode - use hash as a configuration file ID
 * @summary Parallel Mode Configuration File Comparison
 */
export const getTablesManagementConfigurationParallel = (
  params: GetTablesManagementConfigurationParallelParams,
  signal?: AbortSignal,
) => {
  return apiClient<GetTablesManagementConfigurationParallel200One | string>({
    url: `/tables/management/configuration/parallel`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetTablesManagementConfigurationParallelQueryKey = (
  params: GetTablesManagementConfigurationParallelParams,
) => {
  return [
    `/tables/management/configuration/parallel`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTablesManagementConfigurationParallelQueryOptions = <
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationParallelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTablesManagementConfigurationParallelQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>
  > = ({ signal }) => getTablesManagementConfigurationParallel(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTablesManagementConfigurationParallelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>
>;
export type GetTablesManagementConfigurationParallelQueryError = void;

export function useGetTablesManagementConfigurationParallel<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationParallelParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationParallel<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationParallelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
          TError,
          Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTablesManagementConfigurationParallel<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationParallelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Parallel Mode Configuration File Comparison
 */

export function useGetTablesManagementConfigurationParallel<
  TData = Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
  TError = void,
>(
  params: GetTablesManagementConfigurationParallelParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTablesManagementConfigurationParallel>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTablesManagementConfigurationParallelQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Observe connectivity errors for failed configuration file downloads
 * @summary Configuration Management Connectivity Errors
 */
export const postTablesManagementConnectivityErrors = (
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesManagementConnectivityErrors200>({
    url: `/tables/management/connectivity-errors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesManagementConnectivityErrorsBody,
    signal,
  });
};

export const getPostTablesManagementConnectivityErrorsQueryKey = (
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
) => {
  return [
    `/tables/management/connectivity-errors`,
    postTablesManagementConnectivityErrorsBody,
  ] as const;
};

export const getPostTablesManagementConnectivityErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
  TError = unknown,
>(
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesManagementConnectivityErrorsQueryKey(
      postTablesManagementConnectivityErrorsBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>
  > = ({ signal }) =>
    postTablesManagementConnectivityErrors(
      postTablesManagementConnectivityErrorsBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesManagementConnectivityErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>
>;
export type PostTablesManagementConnectivityErrorsQueryError = unknown;

export function usePostTablesManagementConnectivityErrors<
  TData = Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
  TError = unknown,
>(
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementConnectivityErrors<
  TData = Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
  TError = unknown,
>(
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
          TError,
          Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesManagementConnectivityErrors<
  TData = Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
  TError = unknown,
>(
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Configuration Management Connectivity Errors
 */

export function usePostTablesManagementConnectivityErrors<
  TData = Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
  TError = unknown,
>(
  postTablesManagementConnectivityErrorsBody: PostTablesManagementConnectivityErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesManagementConnectivityErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesManagementConnectivityErrorsQueryOptions(
    postTablesManagementConnectivityErrorsBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
